import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("iqes_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  const applyAuth = (data) => {
    localStorage.setItem("iqes_token", data.access_token);
    localStorage.setItem("iqes_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return applyAuth(data);
  };

  const loginWithGoogleSession = async (session_id) => {
    const { data } = await api.post("/auth/google/callback", { session_id });
    return applyAuth(data);
  };

  const logout = () => {
    localStorage.removeItem("iqes_token");
    localStorage.removeItem("iqes_user");
    setUser(null);
  };

  const refresh = async () => {
    const token = localStorage.getItem("iqes_token");
    if (!token) return null;
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("iqes_user", JSON.stringify(data));
      return data;
    } catch {
      logout();
      return null;
    }
  };

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      return;
    }
    if (localStorage.getItem("iqes_token") && !user) {
      refresh();
    }
  }, []); // eslint-disable-line

  return (
    <AuthCtx.Provider value={{ user, login, loginWithGoogleSession, logout, refresh, loading, setLoading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
